import { CategoryTab, Icon, Modal, SearchBar } from 'components';
import UserSearch from 'components/UserSearch/UserSearch';
import { useIsMobile, useResizablePane } from 'hooks';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ContractView from './Components/Contract/ContractView';
import MessageConversation from './Components/Messages/MessageConversation';
import Messages from './Components/Messages/Messages';
import ProposalDetails from './Components/Notifications/Components/ProposalDetails/ProposalDetails';
import Notifications from './Components/Notifications/Notifications';
import './GlobalSearch.scss';
import { FILTER_TABS, TAB_VALUE } from './constants';

const GlobalSearch = ({ isOpen, onClose }) => {
  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState(TAB_VALUE.MESSAGE);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);

  const isMobileViewport = useIsMobile();
  const resultsRef = useRef(null);
  const { handleResizeMouseDown } = useResizablePane(resultsRef);

  const { notificationCount } = useSelector((state) => state.global);

  const onSearchHandler = (search) => {
    if (activeTab === TAB_VALUE.PROFILE) {
      //   setQuery(search);
      setSearch(search);
    } else {
      setSearch(search);
    }
  };

  const onMessageSelectHandler = (message) => {
    setSelectedMessage(message);
    setActiveTab(TAB_VALUE.MESSAGE);
  };

  const onTabChangeHandler = (tab) => {
    if (resultsRef.current) {
      resultsRef.current.style.removeProperty('--global-search-right-width');
    }
    setActiveTab(tab);
    setSelectedMessage(null);
    setSelectedNotificationId(null);
    setSearch('');
    // setQuery('');
  };

  const showLeftOnMobile = activeTab !== TAB_VALUE.MESSAGE || selectedMessage;
  const isNotificationsTab = activeTab === TAB_VALUE.NOTIFICATIONS;
  const showNotificationDetails =
    isNotificationsTab && !isMobileViewport && Boolean(selectedNotificationId);

  const rightPaneContent = (() => {
    if (showNotificationDetails) {
      return (
        <ProposalDetails
          proposalId={selectedNotificationId}
          onClose={() => setSelectedNotificationId(null)}
        />
      );
    }
    if (!isNotificationsTab) {
      return (
        <Messages
          onSelect={onMessageSelectHandler}
          selectedId={selectedMessage?.id}
        />
      );
    }
    return null;
  })();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onClose}
      showFooter={false}
      modalBodyClassName='global-search-modal-body'
      modalOverlayClassName='global-search-modal-overlay'
      modalContentClassName='global-search-modal-content'
    >
      <div className='global-search'>
        <div className='global-search--header'>
          <div className='global-search--header-row'>
            <SearchBar value={search} onChange={onSearchHandler} />
            <Icon
              name='Close_SM'
              onClick={onClose}
              className='global-search--close'
            />
          </div>
          <div className='global-search--tabs'>
            <CategoryTab
              activeTab={activeTab}
              setActiveTab={onTabChangeHandler}
              tabs={FILTER_TABS}
              badgeCounts={{ notifications: notificationCount }}
            />
          </div>
        </div>
        <div
          className='horizontal-line global-search--header--line'
          style={{ marginBottom: '0px' }}
        />
        <div
          className={`global-search--results ${
            showLeftOnMobile ? 'mobile-show-left' : ''
          } ${
            isNotificationsTab && !showNotificationDetails
              ? 'single-column'
              : ''
          }`}
          ref={resultsRef}
        >
          <div className='global-search--results--left'>
            {activeTab === TAB_VALUE.PROFILE && (
              <UserSearch onClose={onClose} searchtext={search} />
            )}
            {activeTab === TAB_VALUE.CONTRACT && (
              <ContractView onClose={onClose} />
            )}
            {(activeTab === TAB_VALUE.MESSAGE || selectedMessage) && (
              <>
                {selectedMessage ? (
                  <MessageConversation
                    data={selectedMessage}
                    onBack={() => setSelectedMessage(null)}
                  />
                ) : (
                  <div className='no-conversation-selected'>
                    Select a conversation to view
                  </div>
                )}
              </>
            )}
            {activeTab === TAB_VALUE.NOTIFICATIONS && (
              <>
                {isMobileViewport && selectedNotificationId ? (
                  <ProposalDetails
                    proposalId={selectedNotificationId}
                    onClose={() => setSelectedNotificationId(null)}
                  />
                ) : (
                  <Notifications
                    onClose={onClose}
                    onSelectNotification={(notification) => {
                      const nextId = notification?.id ?? null;
                      setSelectedNotificationId((prev) =>
                        String(prev) === String(nextId) ? null : nextId
                      );
                    }}
                    selectedNotificationId={selectedNotificationId}
                  />
                )}
              </>
            )}
          </div>
          {rightPaneContent && (
            <>
              <div
                className='global-search--results--resize-handle'
                onMouseDown={handleResizeMouseDown}
                role='separator'
                aria-orientation='vertical'
              />
              <div className='global-search--results--right'>
                {rightPaneContent}
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default GlobalSearch;
